import { render, staticRenderFns } from "./ProspectedCoach.vue?vue&type=template&id=8a6a2e7e"
import script from "./ProspectedCoach.vue?vue&type=script&lang=js"
export * from "./ProspectedCoach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports